import { render, staticRenderFns } from "./CollegeAllClassTestReports.vue?vue&type=template&id=7babb078"
import script from "./CollegeAllClassTestReports.vue?vue&type=script&lang=js"
export * from "./CollegeAllClassTestReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports